import moment from 'moment/moment'
import request from '@/utils/request'
const list = () => {
    const params = { productType: 'fy2g', date: moment().format('YYYYMMDD'), }
    return request.get('/wdt_qiniu_rest/product', params).then((data: any) => {
        if (!data || data.length === 0) return []
        return data
    })


}
export default { list }
